(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-table-of-contents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-article-toc-section]').forEach(function (section) {
      var selector = section.getAttribute('data-content-selector') || '.blog-post-content';
      var includeH3 = section.getAttribute('data-include-h3') === 'true';
      var hideEmpty = section.getAttribute('data-hide-empty') === 'true';
      var content;

      try {
        content = document.querySelector(selector);
      } catch (error) {
        content = document.querySelector('.blog-post-content');
      }

      var nav = section.querySelector('.article-toc-module__nav');
      var list = section.querySelector('[data-article-toc-list]');

      if (!content || !nav || !list) {
        if (hideEmpty) section.remove();
        return;
      }

      var headings = content.querySelectorAll(includeH3 ? 'h2, h3' : 'h2');

      if (!headings.length) {
        if (hideEmpty) section.remove();
        return;
      }

      var usedIds = {};

      headings.forEach(function (heading, index) {
        var text = heading.textContent.trim();
        if (!text) return;

        var baseId = heading.id || 'article-heading-' + index;
        var id = baseId;
        var suffix = 2;

        while (usedIds[id] || document.getElementById(id)) {
          id = baseId + '-' + suffix;
          suffix += 1;
        }

        usedIds[id] = true;
        heading.id = id;

        var item = document.createElement('li');
        var link = document.createElement('a');

        item.className = heading.tagName.toLowerCase();
        link.href = '#' + id;
        link.textContent = text;

        item.appendChild(link);
        list.appendChild(item);
      });

      if (list.children.length) {
        nav.hidden = false;
      } else if (hideEmpty) {
        section.remove();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
